import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { path } from 'ramda'
import { VUE_APP_BASE_AUTH_URL }  from 'constants/fileConstants'

Vue.use(VueAxios, axios)

Vue.axios.defaults.baseURL = VUE_APP_BASE_AUTH_URL

Vue.use(require('@websanova/vue-auth'), {
  auth: {
    request: function (req, token) {
      this.options.http._setHeaders.call(this, req, {
        Authorization: 'Bearer ' + token
      })
    },
    response: function (res) {
      const token = path(['data', 'data', 'token'], res)

      if (token) {
        return token
      }
    }
  },
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  loginData: {
    url: 'auth/login/',
    method: 'POST',
    redirect: '/',
    fetchUser: true
  },
  fetchData: {
    url: 'api/users/me',
    method: 'GET',
    enabled: true
  },
  refreshData: {
    enabled: false
  },
  authRedirect: '/',
  forbiddenRedirect: '/',
  rolesVar: 'role'
})
